var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8V4.88889C4 3.85749 4.42143 2.86834 5.17157 2.13903C5.92172 1.40972 6.93913 1 8 1C9.06087 1 10.0783 1.40972 10.8284 2.13903C11.5786 2.86834 12 3.85749 12 4.88889M2 18H14C14.5523 18 15 17.5523 15 17V9C15 8.44772 14.5523 8 14 8H2C1.44772 8 1 8.44772 1 9V17C1 17.5523 1.44772 18 2 18Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.806218d6096b315ebd49f4f107761dcb.svg";
export { ForwardRef as ReactComponent };